<ng-template #template let-row="row">
  <ng-container *ngIf="!hasPeriodId(row); else periodInfo"> - </ng-container>

  <ng-template #periodInfo>
    <div class="flex--column">
      <div>{{ getSalesOrderPeriodName(row) }}</div>
      <div class="text--label" *ngIf="hasPeriodId(row)">
        {{ getPeriodStartDate(row) | agrDate }}
        {{ 'cart-column-delivery-period.sales-order-period-to' | translate }}
        {{ getPeriodEndDate(row) | agrDate }}
      </div>
    </div>
  </ng-template>
</ng-template>
